module.exports = __webpack_public_path__ + "img/unresolved.5f2718fd.svg";